import MediumPosts from './MediumPosts';

export default MediumPosts;
